module.exports = __webpack_public_path__ + "static/404-2e913c77bf7804924ebca44055c6970c.png";